import { RouteWrapper } from "./RouteWrapper";

export const createRouteElement = (element: React.ReactNode): JSX.Element => {
  const wrappedElement = <RouteWrapper>{element}</RouteWrapper>;
  return wrappedElement;
};
